/**
 * YOKAI CASES - filter product gallery by selected phone model (Horizon theme).
 * Image alt format: "iPhone 16 | front", "Samsung Galaxy S25 | close-up"
 */
(function () {
  'use strict';
  var ALT_SEP = ' | ';
  var MAX_VIEWS = 5;
  var VIEW_ORDER = ['front', 'front-and-side', 'side', 'close-up', 'close-up-2', 'context-1', 'layers'];

  function getVariantTitle() {
    var picker = document.querySelector('variant-picker');
    if (picker) {
      var sel = picker.querySelector('select[name^="options"]');
      if (sel && sel.options && sel.options.length) {
        return sel.options[sel.selectedIndex].textContent.trim();
      }
      var checked = picker.querySelector('input[type="radio"]:checked');
      if (checked) {
        var lbl = picker.querySelector('label[for="' + checked.id + '"]');
        return (lbl ? lbl.textContent : checked.value).trim();
      }
    }
    var idInput = document.querySelector('form.shopify-product-form input[name="id"], [name="id"]');
    if (idInput && idInput.tagName === 'SELECT') {
      return idInput.options[idInput.selectedIndex].textContent.trim();
    }
    var opt = document.querySelector('select.variant-option__select option:checked, select.variant-option__select');
    if (opt) return (opt.textContent || opt.value).trim();
    return null;
  }

  function hideNode(node) {
    if (!node) return;
    node.setAttribute('data-yokai-hidden', '1');
    node.style.setProperty('display', 'none', 'important');
    node.setAttribute('aria-hidden', 'true');
  }

  function showNode(node) {
    if (!node) return;
    node.removeAttribute('data-yokai-hidden');
    node.style.removeProperty('display');
    node.removeAttribute('aria-hidden');
  }

  function findSlide(img) {
    return (
      img.closest('slideshow-slide') ||
      img.closest('[data-media-id]') ||
      img.closest('.product-media-container') ||
      img.closest('button.product-media') ||
      img.closest('li') ||
      img.parentElement
    );
  }

  function sameSrc(a, b) {
    if (!a || !b) return false;
    var na = a.split('?')[0].split('/').pop();
    var nb = b.split('?')[0].split('/').pop();
    return na === nb || a.indexOf(nb) !== -1 || b.indexOf(na) !== -1;
  }

  function pickFrontImage(variantTitle) {
    var imgs = Array.from(document.querySelectorAll('media-gallery img[alt], .product-media img[alt], slideshow-component img[alt]'));
    return (
      imgs.find(function (img) {
        var alt = img.getAttribute('alt') || '';
        return alt === variantTitle + ALT_SEP + 'front';
      }) ||
      imgs.find(function (img) {
        var alt = img.getAttribute('alt') || '';
        return alt.indexOf(variantTitle + ALT_SEP) === 0;
      }) ||
      null
    );
  }

  function activateMainSlide(variantTitle) {
    var front = pickFrontImage(variantTitle);
    if (!front) return;
    var src = front.currentSrc || front.src || '';
    var thumbs = document.querySelectorAll(
      'button.slideshow-controls__thumbnail, button.thumbnail, button.product-media, [data-media-id] button'
    );
    thumbs.forEach(function (btn) {
      var img = btn.querySelector('img');
      if (!img) return;
      var tsrc = img.currentSrc || img.src || '';
      if (sameSrc(tsrc, src)) btn.click();
    });
    var slide = findSlide(front);
    if (slide) {
      var sc = slide.closest('slideshow-component');
      if (sc && typeof sc.select === 'function') {
        try { sc.select(slide); } catch (e) { /* ignore */ }
      }
      var idx = Array.from(slide.parentElement.children).indexOf(slide);
      var dots = document.querySelectorAll('slideshow-controls button, .slideshow-controls__thumbnail');
      if (dots[idx]) dots[idx].click();
    }
  }

  function parseAlt(alt) {
    if (!alt || alt.indexOf(ALT_SEP) === -1) return null;
    var parts = alt.split(ALT_SEP);
    return { model: parts[0].trim(), view: (parts[1] || '').trim() };
  }

  function viewRank(view) {
    var i = VIEW_ORDER.indexOf(view);
    return i === -1 ? 99 : i;
  }

  function filterGallery(variantTitle) {
    if (!variantTitle) return;
    var candidates = [];
    document.querySelectorAll('media-gallery img[alt], .product-media img[alt], slideshow-component img[alt]').forEach(function (img) {
      var parsed = parseAlt(img.getAttribute('alt') || '');
      var slide = findSlide(img);
      if (!slide) return;
      if (!parsed || parsed.model !== variantTitle) {
        hideNode(slide);
        return;
      }
      candidates.push({ slide: slide, view: parsed.view, img: img });
    });
    candidates.sort(function (a, b) { return viewRank(a.view) - viewRank(b.view); });
    var shown = 0;
    candidates.forEach(function (c, idx) {
      if (idx < MAX_VIEWS) {
        showNode(c.slide);
        shown++;
      } else {
        hideNode(c.slide);
      }
    });
    if (shown === 0) {
      document.querySelectorAll('[data-yokai-hidden]').forEach(showNode);
    }
    activateMainSlide(variantTitle);
  }

  function run() {
    var title = getVariantTitle();
    filterGallery(title);
    setTimeout(function () { filterGallery(getVariantTitle()); }, 120);
    setTimeout(function () { filterGallery(getVariantTitle()); }, 400);
  }

  function init() {
    run();
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.name && (t.name.indexOf('options') === 0 || t.name === 'id')) run();
      if (t.closest && t.closest('variant-picker')) run();
    });
    document.addEventListener('variant:change', run);
    var picker = document.querySelector('variant-picker');
    if (picker) {
      new MutationObserver(run).observe(picker, { childList: true, subtree: true, attributes: true });
    }
    var gallery = document.querySelector('media-gallery');
    if (gallery) {
      new MutationObserver(function () { setTimeout(run, 50); }).observe(gallery, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();